import { featureCards } from "../data/homePageContent";

export function FeatureGrid() {
  return (
    <section className="site-shell section" id="how-it-works">
      <div className="section-heading reveal">
        <p className="kicker">How it works</p>
        <h2>Tax preparation without the paperwork headache.</h2>
      </div>
      <div className="feature-grid">
        {featureCards.map((card) => (
          <article className="feature-card" key={card.title}>
            <div className="feature-card__index">{card.index}</div>
            <h3>{card.title}</h3>
            <p>{card.body}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
